module.exports = __webpack_public_path__ + "static/media/17.2e590a52.JPG";